import GenerateComparisonTable from "./_GenerateComparisonTable";
import TableScroll from "./_TableScroll";

TableScroll();
GenerateComparisonTable();